// Shared by the flat per-dashboard slices (core/model/trade/optimization/panels): drops a
// dashboardId key from state without an unmount GC hook. Only touches the outer keys, so it works
// for any slice shape keyed by dashboardId. [APP-3309]
export function removeInstanceKey<S extends Record<string, unknown>>(state: S, dashboardId: string): S {
  if (state[dashboardId] === undefined) return state
  return Object.fromEntries(
    Object.entries(state).filter(([key]) => key !== dashboardId),
  ) as S
}
